import React from 'react';
import Link from 'next/link';
import { GlobalIcon, IconImage } from 'src/modules/global';
import classes from './Breadcrumbs.module.scss';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

export interface BreadcrumbLink {
  title: string;
  href?: string;
  as?: string;
  capitalizeLabel?: boolean;
}

export interface BreadcrumbsProps {
  links: BreadcrumbLink[];
  horizontalMargins?: boolean;
}

export const Breadcrumbs = ({ links, horizontalMargins = true }: BreadcrumbsProps) => {
  const intl = useIntl();

  return (
    <div className={classnames(classes.container, horizontalMargins && classes.horizontalMargins)}>
      <Link href={'/'} as={'/'}>
        <a className={classnames(classes.link, classes.first)}>
          {intl.formatMessage({ id: 'breadcrumbs/home' })}
        </a>
      </Link>
      <GlobalIcon image={IconImage.RightArrow} size="custom" className={classes.icon} />
      {links.map(({ href, as: url, title, capitalizeLabel = true }, i) => {
        const classname = classnames(
          classes.link,
          i === links.length - 1 && classes.last,
          capitalizeLabel && classes.capitalized
        );
        return (
          <React.Fragment key={`breadcrumb-${i}`}>
            {href ? (
              <Link href={href} as={url}>
                <a className={classname}>{title}</a>
              </Link>
            ) : (
              <span className={classname}>{title}</span>
            )}
            {i < links.length - 1 && (
              <GlobalIcon image={IconImage.RightArrow} size="custom" className={classes.icon} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
